import { FormattedMessage } from 'react-intl';
import {
  IconArrowDownCircle,
  IconClipboardCheck,
  IconDashboard,
  IconDeviceAnalytics,
  IconHelp,
  IconPhoneCall,
  IconPhoto,
  IconSettings,
  IconShoppingCart,
  IconSwitch2,
  IconThumbDown,
  IconTransfer,
  IconUserExclamation,
  IconUserHexagon,
  IconUsers,
  IconWallet,
  IconWoman,
} from '@tabler/icons-react';

import { PERMISSION_ACTION, PERMISSION_SUBJECT } from '@config/permissions';

import { MenuProps } from './types';

// constant
const icons = {
  IconDashboard,
  IconDeviceAnalytics,
  IconClipboardCheck,
  IconThumbDown,
  IconUsers,
  IconWoman,
  IconShoppingCart,
  IconSwitch2,
  IconTransfer,
  IconArrowDownCircle,
  IconUserExclamation,
  IconUserHexagon,
  IconSettings,
  IconHelp,
  IconPhoneCall,
  IconWallet,
  IconPhoto,
};

const ROOT_PATH = '/';

export const sidebarMenuItems: MenuProps = {
  id: 'dashboard-menu',
  title: '',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: <FormattedMessage id="dashboard" />,
      type: 'item',
      url: `${ROOT_PATH}dashboard`,
      icon: icons.IconDashboard,
      breadcrumbs: true,
      requiredPermission: {
        action: PERMISSION_ACTION.VIEW,
        subject: PERMISSION_SUBJECT.DASHBOARD,
      },
    },
    {
      id: 'users',
      title: <FormattedMessage id="users" />,
      type: 'item',
      url: `${ROOT_PATH}users`,
      icon: icons.IconUsers,
      breadcrumbs: true,
      requiredPermission: {
        action: PERMISSION_ACTION.VIEW,
        subject: PERMISSION_SUBJECT.DASHBOARD,
      },
    },
    {
      id: 'affiliates',
      title: <FormattedMessage id="affiliates" />,
      type: 'collapse',
      url: `${ROOT_PATH}affiliates`,
      icon: icons.IconWoman,
      breadcrumbs: true,
      requiredPermission: {
        action: PERMISSION_ACTION.VIEW,
        subject: PERMISSION_SUBJECT.DASHBOARD,
      },
      children: [
        {
          id: 'affiliates-profile-transfer',
          title: 'Profile Transfer',
          type: 'item',
          url: `${ROOT_PATH}affiliates/profile-transfer`,
          icon: icons.IconTransfer,
          breadcrumbs: true,
          requiredPermission: {
            action: PERMISSION_ACTION.VIEW,
            subject: PERMISSION_SUBJECT.DASHBOARD,
          },
        },
        {
          id: 'affiliates-online-offline-access',
          title: 'Online/Offline Access',
          type: 'item',
          url: `${ROOT_PATH}affiliates/online-offline-access`,
          icon: icons.IconSwitch2,
          breadcrumbs: true,
          requiredPermission: {
            action: PERMISSION_ACTION.VIEW,
            subject: PERMISSION_SUBJECT.DASHBOARD,
          },
        },
      ],
    },
    {
      id: 'administrators',
      title: <FormattedMessage id="administrators" />,
      type: 'item',
      url: `${ROOT_PATH}administrators`,
      icon: icons.IconUserHexagon,
      breadcrumbs: true,
      requiredPermission: {
        action: PERMISSION_ACTION.VIEW,
        subject: PERMISSION_SUBJECT.DASHBOARD,
      },
    },
    {
      id: 'payments',
      title: <FormattedMessage id="payments" />,
      type: 'item',
      url: `${ROOT_PATH}payments`,
      icon: icons.IconWallet,
      breadcrumbs: true,
      requiredPermission: {
        action: PERMISSION_ACTION.VIEW,
        subject: PERMISSION_SUBJECT.DASHBOARD,
      },
    },
    {
      id: 'withdrawals',
      title: <FormattedMessage id="withdrawals" />,
      type: 'item',
      url: `${ROOT_PATH}withdrawals`,
      icon: icons.IconArrowDownCircle,
      breadcrumbs: true,
      requiredPermission: {
        action: PERMISSION_ACTION.VIEW,
        subject: PERMISSION_SUBJECT.DASHBOARD,
      },
      children: [
        {
          id: 'users-user-id',
          paramsKey: 'userId',
          type: 'item',
          url: `${ROOT_PATH}users/:userId/`,
          icon: icons.IconUsers,
          breadcrumbs: true,
          requiredPermission: {
            action: PERMISSION_ACTION.VIEW,
            subject: PERMISSION_SUBJECT.DASHBOARD,
          },
        },
      ],
    },
    {
      id: 'photos',
      title: <FormattedMessage id="photo" />,
      type: 'item',
      url: `${ROOT_PATH}photos`,
      icon: icons.IconPhoto,
      breadcrumbs: true,
      requiredPermission: {
        action: PERMISSION_ACTION.VIEW,
        subject: PERMISSION_SUBJECT.DASHBOARD,
      },
    },
    {
      id: 'reports',
      title: <FormattedMessage id="reports" />,
      type: 'item',
      url: `${ROOT_PATH}reports`,
      icon: icons.IconDeviceAnalytics,
      breadcrumbs: true,
      requiredPermission: {
        action: PERMISSION_ACTION.VIEW,
        subject: PERMISSION_SUBJECT.DASHBOARD,
      },
    },
    {
      id: 'system',
      title: <FormattedMessage id="system" />,
      type: 'item',
      url: `${ROOT_PATH}system`,
      icon: icons.IconSettings,
      breadcrumbs: true,
      requiredPermission: {
        action: PERMISSION_ACTION.VIEW,
        subject: PERMISSION_SUBJECT.SYSTEM,
      },
    },
  ],
};
